<div class="flex flex-wrap gap-5 p-5">
    <input type="month">
    @for (ship of ships; track $index) {
    <div class="rounded-[10px] w-full p-2.5 border-black border-[1px] gap-5 flex bg-white bg-opacity-70 backdrop-blur-sm">
        <div>
            <div class="size-[285px] rounded-[12px] bg-cover bg-center bg-no-repeat" [style]="'background-image:url(' + baseUrl + '/image/' + ship.images[0].url + ')'"></div>
            <div class="flex items-center mt-2.5 w-[285px]">
                <div>
                    <div class="text-secondary text-[28px] font-medium">{{ship.title}}</div>
                </div>
            </div>
        </div>
        <div class="flex flex-wrap gap-2.5">
            @for (available of ship.slotOfDay; track $index) {
                <div class="flex p-2 gap-2 shadow-md rounded-xl h-fit items-center select-none">
                    <div class="font-semibold text-[24px]">{{available.day}}</div>
                    <div class="size-6 bg-green-500 rounded-sm" [ngClass]="{'bg-red-600': !available.available}"></div>
                </div>
            }
        </div>
    </div>
    }
</div>